import karliMason from '../../../assets/website/images/Karli-Mason.jpg'
import stefanyWedge from '../../../assets/website/images/Stefany-Wedge.jpg'
import OutStorySection from './outStory';

function MeetTheFoundersPage() {
  return (
    <main>
      <section className="aboutus-banner-section section-padding">
        <div className="container">
          <div className="banner-content">
            <div className="banner-text section-head">
              <h1 className="h1-headline">Meet the Woman Behind babe</h1>
              <p className="body-1">
                Because supporting women at every stage starts with living it
                myself.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="meet-founders section-padding">
        <div className="container">
          <div className="sub-heading mb-5">
            <h2 className="h2-headline">Meet the founders</h2>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-5">
              <div className="team-box">
                <figure className="team-image">
                  <img
                    src={karliMason}
                    alt="team1"
                    className="img-fluid"
                    width="200px"
                    height="200px"
                  />
                </figure>
                <figcaption>
                  <h4 className="h4-headline">Karli Mason</h4>
                  <h6 className="h6-headline">babe, Co-Founder</h6>
                  {/* <p className="body-1">
                    A former wellness editor turned entrepreneur, Amara created
                    babe to be the kind of space she wished existed during her
                    own life transitions
                  </p> */}
                </figcaption>
              </div>
            </div>

            <div className="col-md-5">
              <div className="team-box">
                <figure className="team-image">
                  <img
                    src={stefanyWedge}
                    alt="team1"
                    className="img-fluid"
                    width="200px"
                    height="200px"
                  />
                </figure>
                <figcaption>
                  <h4 className="h4-headline">Stefany Wedge</h4>
                  <h6 className="h6-headline">babe, Co-Founder</h6>
                  {/* <p className="body-1">
                    With a background in integrative health and women’s
                    advocacy, Nyla is the heart behind babe’s wellness
                    initiatives.
                  </p> */}
                </figcaption>
              </div>
            </div>

            <div className='col-12'>
              <p className="body-1">
                With a background in integrative health and women’s
                advocacy, Nyla is the heart behind babe’s wellness
                initiatives.
              </p>
            </div>
          </div>
        </div>
      </section>



      <section className="Why-babe-exists section-padding">
        <div className="container">
          <div className="Why-babe-wrap">
            <div className="Why-babe-in">
              <div className="text-box">
                <h2 className="h2-headline">Why <span style={{ textTransform: "lowercase" }}>babe</span> Exists</h2>
              </div>
              <div className="row align-items-center justify-content-center text-center">
                <div className="col-md-5">
                  <div className="our-mission-box">
                    <h4 className="h4-headline">Our Mission</h4>
                    <h6 className="h6-headline">
                      babe is here to walk alongside women through every messy,
                      beautiful, complicated stage of life. Whether it's
                      navigating new motherhood, identity shifts, burnout, or
                      bold beginnings — we offer real support, heartfelt
                      community, and tools designed for you.
                    </h6>
                  </div>
                </div>

                <div className="col-md-1 d-none d-md-block">
                  <div className="vertical-divider"></div>
                </div>

                <div className="col-md-5">
                  <div className="our-mission-box">
                    <h4 className="h4-headline">Our Vision</h4>
                    <h6 className="h6-headline">
                      We imagine a world where women no longer have to “power
                      through” alone — where asking for help is celebrated, and
                      being in transition doesn’t mean being invisible. We want
                      every woman to feel seen, supported, and rooted in her
                      worth — every step of the way.
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <OutStorySection />

    </main>
  );
}

export default MeetTheFoundersPage;
